import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../configHelper';

@Injectable({
  providedIn: 'root'
})
export class ResultSigningDataService {
  constructor(private httpClient: HttpClient, private configService: ConfigService) {
  }

  public searchResultsToBeSigned(start, length, sortBy, sortDirection, search) {
    var params = `start=${start}&length=${length}&search=${JSON.stringify(search)}`;

    if (sortBy) {
      params += `&sortBy=${sortBy}&sortDirection=${sortDirection}`;
    }
    else {
      params += `&sortBy=&sortDirection=`;
    }

    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/TestReportSigning/SearchResultsToSign?${params}`;
    return this.httpClient.get(url);
  }

  public signResults(resultId) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/TestReportSigning/SignResults?RequisitionTestResultId=${resultId}`;
    return this.httpClient.get(url);
  }

  public getTestInfo(requisitionTestId) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/TestReportSigning/GetTestInfo?requisitionTestId=${requisitionTestId}`;
    return this.httpClient.get(url);
  }

  public updateTestInfo(dto: any) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/TestReportSigning/UpdateTestInfo`;
    return this.httpClient.post(url, dto);
  }

}
